import { useEffect, useState } from 'react';
import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';
import { useSalesStatus } from '@/components/_shared/contexts/SalesStatusContext';
import { useTicketInformation } from '@/hooks/useTicketInformation/useTicketInformation';
import { QUERY_PARAMS } from '../../../../common/constants';
import { shouldDisplayRsvp as computeShouldDisplayRsvp } from '../utils';
import { HAS_WINDOW } from '@eventbrite/feature-detection';

export interface RsvpParamsState {
  mipaToken: string | null;
}

export const useShouldDisplayRsvp = () => {
  const [rsvpParams, setUrlParams] = useState<RsvpParamsState>({
    mipaToken: null,
  });

  useEffect(() => {
    if (!HAS_WINDOW) return;
    const params = new URLSearchParams(window.location.search);
    setUrlParams({
      mipaToken: params.get(QUERY_PARAMS.MIPA),
    });
  }, []);

  const { status } = useBasicInfo();
  const { displayStatus } = useSalesStatus();
  const [ticketInfo] = useTicketInformation();

  const shouldDisplayRsvp = computeShouldDisplayRsvp(rsvpParams.mipaToken, status, displayStatus, ticketInfo);

  return {
    shouldDisplayRsvp,
    mipaToken: rsvpParams.mipaToken,
  };
};
